import React, { useEffect, useState, useRef } from "react";
import popSound from "../sounds/balloon-pop.mp3"; // Import sound
import winner from "../sounds/winner.mp3";
import "../css/Balloon.css"; // External CSS file for better management
import { Box } from "@mui/material";
import Colors from "./Colors";

const FloatingBalloon = ({ hasWinner }) => {
  console.log(hasWinner);
  const [burst, setBurst] = useState(false);
  const [showCracker, setShowCracker] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const audioRef = useRef(new Audio(winner));

  useEffect(() => {
    if (hasWinner) {
      setBurst(true); // Hide balloon
      setShowCracker(true); // Show cracker animation
      setShowAlert(true); // Show alert message

      // Play pop sound
      const audio = audioRef.current;
      audio.volume = 1.0;
      audio.play().catch((error) => console.error("Sound error:", error));

      // Reset animations after 3 seconds
      setTimeout(() => {
        setShowCracker(false);
        setShowAlert(false);
      }, 3000);
    } else {
      // Reset everything when hasWinner becomes false
      setBurst(false);
      setShowCracker(false);
      setShowAlert(false);
    }
  }, [hasWinner]);

  return (
    <div className="balloon-wrapper">
      {/* Winner Alert */}
      {showAlert && (
        <Box
          className="winner-alert"
          sx={{
            width: "85vw",
            height: "40px",
            justifyContent: "center",
            marginTop: "2%",
            alignItems: "center",
            background: Colors.Tidesbg,
            fontFamily: "Boogaloo",
            fontSize: "24px",
            textAlign: "center",
            borderRadius: "12px",
          }}
        >
          🎉 We got today's winner! 🎉
        </Box>
      )}

      {/* Fireworks Animation */}
      {showCracker && (
        <div className="cracker-container">
          <div className="firework"></div>
          <div className="firework delay"></div>
          <div className="firework delay2"></div>
        </div>
      )}

      {/* Balloon (only visible when there is no winner) */}
      {!burst && (
        <div className="balloon-container">
          <div className="balloon">
            <div className="balloon-knot"></div>
            <svg className="curved-thread" viewBox="0 0 50 150">
              <path
                d="M25,0 Q15,75 25,150"
                stroke="gray"
                strokeWidth="2"
                fill="none"
              />
            </svg>
          </div>
        </div>
      )}
    </div>
  );
};

export default FloatingBalloon;
